import { RequestKind, boolean, string } from '@sb/library/base';
import { DisplayItemCollection, MembershipCreateStripeSubscriptionInputItem, MembershipPlanDisplayItem, MembershipPlanSearchOptions, MembershipSubscriptionDeleteOptions, MembershipSubscriptionDisplayItem, MembershipSubscriptionInputItem, MembershipSubscriptionUpdateItem, MembershipTransactionDisplayItem, MembershipTransactionSearchOptions, PayPalMembershipSubscriptionInputItem, SubscriptionResultItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace MembershipRoutes {
    export const Get = ApiRoute.Define({
        URL: (membershipPlanID: string) => `membershipplans/${membershipPlanID}`,
        Kind: RequestKind.Get,
        ResultType: MembershipPlanDisplayItem
    });

    export const Search = ApiRoute.Define({
        URL: 'search/membershipplans',
        Kind: RequestKind.Post,
        BodyType: MembershipPlanSearchOptions,
        ResultType: DisplayItemCollection<MembershipPlanDisplayItem>
    });

    export namespace Subscription {
        export const Get = ApiRoute.Define({
            URL: 'membership',
            Kind: RequestKind.Get,
            ResultType: MembershipSubscriptionDisplayItem
        });

        export const GetPayPalURL = ApiRoute.Define({
            URL: 'membership/paypalurl',
            Kind: RequestKind.Post,
            BodyType: PayPalMembershipSubscriptionInputItem,
            ResultType: string
        });

        export const GetStripePaymentIntent = ApiRoute.Define({
            URL: 'membership/stripesubscription',
            Kind: RequestKind.Post,
            BodyType: MembershipCreateStripeSubscriptionInputItem,
            ResultType: SubscriptionResultItem
        });
    }

    export namespace Transaction {
        export const Get = ApiRoute.Define({
            URL: (membershipTransactionID: string) => `membership/transactions/${membershipTransactionID}`,
            Kind: RequestKind.Get,
            ResultType: MembershipTransactionDisplayItem
        });

        export const Search = ApiRoute.Define({
            URL: 'search/membership/transactions',
            Kind: RequestKind.Post,
            BodyType: MembershipTransactionSearchOptions,
            ResultType: DisplayItemCollection<MembershipTransactionDisplayItem>,
            PagingAllowed: true
        });
    }

    export const Subscribe = ApiRoute.Define({
        URL: 'membership',
        Kind: RequestKind.Post,
        BodyType: MembershipSubscriptionInputItem,
        ResultType: SubscriptionResultItem
    });

    export const Update = ApiRoute.Define({
        URL: 'membership',
        Kind: RequestKind.Patch,
        BodyType: MembershipSubscriptionUpdateItem,
        ResultType: boolean
    });

    export const Unsubscribe = ApiRoute.Define({
        URL: 'membership',
        Kind: RequestKind.Delete,
        BodyType: MembershipSubscriptionDeleteOptions,
        ResultType: boolean
    });
}
